import { render } from "./QuestionElement.vue?vue&type=template&id=6d846d7d"
import script from "./QuestionElement.vue?vue&type=script&lang=js"
export * from "./QuestionElement.vue?vue&type=script&lang=js"

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__